import { c as _c } from "react/compiler-runtime";
import { accountSettingsPreferencesTab } from "@pages/account-settings/account-settings-preferences-tab";
import { accountSettingsSecurityTab } from "@pages/account-settings/account-settings-security-tab";
import { integrationsAccountTab } from "@pages/account-settings/integrations-account/integrations-account-tab";
import { useUserContext } from "@pages/account-settings/user-provider";
import { AccountSettingsTabs, QueryParams } from "@router/route-params";
import { generateAccountSettingsRoute } from "@router/router-helper";
import { useRedirectToPage } from "@hooks/use-redirect-to-page";
import { useMemo } from "react";
import { accountSettingsPrivacyTab } from "@pages/account-settings/integrations-account/privacy-account-tab";
import { appStateSelector } from "@store/app/app-selector";
import { useAppSelector } from "@store/store-helper";
/** The tabs used for account settings */
export function useAccountSettingsTabs() {
  const $ = _c(21);
  const {
    user
  } = useUserContext();
  const {
    isBetaTestingEnabled
  } = useAppSelector(appStateSelector);
  const t0 = !user;
  let t1;
  if ($[0] !== user) {
    t1 = user ? accountSettingsSecurityTab({
      user
    }) : [];
    $[0] = user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      routeId: AccountSettingsTabs.security,
      label: "Account & security",
      isHidden: t0,
      content: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isBetaTestingEnabled) {
    t3 = accountSettingsPreferencesTab({
      isBetaTestingEnabled
    });
    $[5] = isBetaTestingEnabled;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      routeId: AccountSettingsTabs.preferences,
      label: "Language & units",
      content: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      routeId: AccountSettingsTabs.privacy,
      label: "Privacy",
      content: accountSettingsPrivacyTab()
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = !user;
  let t7;
  if ($[10] !== user) {
    t7 = user ? integrationsAccountTab() : [];
    $[10] = user;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = {
      routeId: AccountSettingsTabs.integrations,
      label: "Integration accounts",
      isHidden: t6,
      content: t7
    };
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t2 || $[16] !== t4 || $[17] !== t8) {
    t9 = {
      [AccountSettingsTabs.security]: t2,
      [AccountSettingsTabs.preferences]: t4,
      [AccountSettingsTabs.privacy]: t5,
      [AccountSettingsTabs.integrations]: t8
    };
    $[15] = t2;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const accountSettingsTabs = t9;
  let t10;
  if ($[19] !== accountSettingsTabs) {
    t10 = {
      accountSettingsTabs
    };
    $[19] = accountSettingsTabs;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}

/**
 *
 * Hook to redirect to the account settings page; preserves the origin route in the query params.
 * It will redirect outside the SPA and pass the current pathname and query params
 */
export function useRedirectToAccountSettingsPage() {
  const $ = _c(2);
  const redirectToPage = useRedirectToPage();
  let t0;
  if ($[0] !== redirectToPage) {
    t0 = accountSettingsTab => {
      const route = generateAccountSettingsRoute(accountSettingsTab);
      redirectToPage({
        route,
        options: {
          shouldPreserveOrigin: true,
          originParamName: QueryParams.settingsOriginUrl
        }
      });
    };
    $[0] = redirectToPage;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

/** Return true when the guest user is allowed to open the account settings tab */
export function canGuestOpenAccountSettingsTab(accountSettingsTab) {
  return accountSettingsTab === AccountSettingsTabs.preferences || accountSettingsTab === AccountSettingsTabs.privacy;
}

/** Returns the header ("Metric" or "Imperial") for the given unit type */
export function getUnitHeader(unitType) {
  return unitType === "meters" || unitType === "millimeters" ? "Metric" : "Imperial";
}